/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FORM : FIELD : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	field: {
		position: 'relative',
		display: 'inline-block',
		textAlign: 'left',
		transition: 'all .15s ease-out 0s',
		// disabled field
        '&.disabled-true': {
            extend: disable
        },
		// form fields
		'& .formelement': {
			// width: pxToEm(260),
			height: pxToEm(48),
			padding: replacePXinStringWithEM(`0 10px`),
			display: 'flex',
			alignItems: 'flex-start',
			alignContent: 'flex-start',
			position: 'relative',
			zIndex: '2',
			transition: theme.animation.general('all'),
			border: replacePXinStringWithEM(`1px solid transparent`),
			borderRadius: pxToEm(5),
			background: theme.color.supporting.light.swatch,
			color: theme.color.supporting.light.contrast,
			'& .icon': {
				width: pxToEm(30),
				height: pxToEm(50),
				display: 'flex',
				alignContent: 'center',
				alignItems: 'center',
				justifyContent: 'flex-start'
			},
			'& .element': {
				flex: '1',
				height: 'inherit'
			},
			'&:hover': {
				filter: 'brightness(97%)'
			}
		},

		// type overrides
		'&.type': {
			'&-checkbox': {
				display: 'flex',
				flexFlow: 'row nowrap',
				minWidth: '0 !important',
				alignContent: 'center',
				alignItems: 'center',
				margin: '0',
				'& .label': {
					marginBottom: '0'
				},
				'& .formelement': {
					order: '-1',
					height: 'auto',
					backgroundColor: 'transparent',
					border: '0',
					padding: '0',
					'& .element': {
						lineHeight: '0'
					}
				}
			},
			'&-radio': {
				display: 'flex',
				flexFlow: 'row nowrap',
				minWidth: '0 !important',
				alignContent: 'center',
				alignItems: 'center',
				margin: '0',
				'& .label': {
					marginBottom: '0'
				},
				'& .formelement': {
					order: '-1',
					height: 'auto',
					backgroundColor: 'transparent',
					border: '0',
					padding: '0',
					'& .element': {
						lineHeight: '0'
					}
				}
			}
		},

		// state of a form field
		'&.icon-true': {
			'& label': {
				transform: replacePXinStringWithEM('translate(30px, 160%)')
			}
		},
		'&.isActive-true': {
			'& .formelement': {
				borderColor: `${theme.color.supporting.dark.swatch} !important`
			}
		},
		'&.hasValue-true': {
			
		},

		// **** ERROR STATE **** //
		'&.isValid-false': {
			'& .label': {
				color: theme.color.attention.dark.swatch,
			},
			'& .formelement': {
				backgroundColor: theme.color.attention.medium.swatch,
				color: theme.color.attention.medium.contrast,
				borderColor: 'transparent'
			},
			'&.isActive-true': {
				'& .formelement': {
					borderColor: `${theme.color.attention.dark.swatch} !important`
				}
			}
		},


		// variants
		// checkbox surrounded by border
		'&.variant-box': {
			border: `${pxToEm(2)} solid ${theme.color.neutral.light.swatch}`,
            borderRadius: pxToEm(4),
            padding: replacePXinStringWithEM(`12px 18px`),
            '& input[type=checkbox]': {
            	marginRight: pxToEm(25)
            },
            '& input[type=radio]': {
            	marginRight: pxToEm(25)
            }
		}
	}
});